export default __webpack_public_path__ + "images/7f78d7d4ba43a504a1020efae428c767-general_health_icon.png";